import { ConsultingRoomsI } from "@interfaces/search";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const consultingRooms = createSlice({
    name: 'create-appointment',
    initialState: {
        rooms: []
    } as { rooms: ConsultingRoomsI[] },
    reducers: {
        setConsultingRooms: (state, action: PayloadAction<{rooms: ConsultingRoomsI[]}>) => {
            state.rooms = action.payload.rooms
        },
        cleanConsultingRooms: (state) => {
            state.rooms.splice(0)
        },
    },
});

export const { setConsultingRooms, cleanConsultingRooms } = consultingRooms.actions;
export default consultingRooms.reducer;